import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../ui/Tooltip';
import { NewPageGlyph, NewFolderGlyph } from './treeIcons';
import WorkspaceChip from './WorkspaceChip';
import WorkspaceSwitcher from './WorkspaceSwitcher';
import LocalCapHint from '../plans/LocalCapHint';

/**
 * The top of the Documents sidebar (card 1.2), 48 px: the scope switcher on
 * the left (WorkspaceSwitcher — its chip shows a workspace's icon and colour,
 * card 5.2) and New document / New folder on the right. With a single choice
 * and workspaces off (signed out, flag off) the switcher is a plain label
 * without a chevron: there is nothing to pick.
 */
export default function SidebarHeader({
  choices,
  current,
  onPick,
  userName,
  onNewDocument,
  onNewFolder,
  workspacesOn = false,
  onNewWorkspace,
  onManageWorkspaces,
  onMoveTree,
  onReorderWorkspaces,
  ns,
}) {
  const { t } = useTranslation();

  return (
    <div className="doc-sidebar-header">
      {choices.length > 1 || workspacesOn ? (
        <WorkspaceSwitcher
          choices={choices}
          current={current}
          onPick={onPick}
          userName={userName}
          workspacesOn={workspacesOn}
          onNewWorkspace={onNewWorkspace}
          onManageWorkspaces={onManageWorkspaces}
          onMoveTree={onMoveTree}
          onReorder={onReorderWorkspaces}
          ns={ns}
        />
      ) : (
        <div className="doc-scope-static" aria-label={t('docSidebar.scope.current', { name: current.label })}>
          <WorkspaceChip choice={current} userName={userName} />
          <span className="doc-scope-static-label">{current.label}</span>
        </div>
      )}
      <div className="doc-sidebar-header-actions">
        {/* Plans v2 card 3.3: own documents only; a team's are not capped. */}
        {current?.scope?.type !== 'team' && <LocalCapHint kind="documents" />}
        <Tooltip content={t('docSidebar.newDocument')} side="bottom">
          <button type="button" className="doc-header-btn" aria-label={t('docSidebar.newDocument')} onClick={onNewDocument}>
            <NewPageGlyph size={16} />
          </button>
        </Tooltip>
        <Tooltip content={t('docSidebar.newFolder')} side="bottom">
          <button type="button" className="doc-header-btn" aria-label={t('docSidebar.newFolder')} onClick={onNewFolder}>
            <NewFolderGlyph size={16} />
          </button>
        </Tooltip>
      </div>
    </div>
  );
}
